import React, { useMemo, useState } from "react";
import { Modal, Tooltip } from "../../common/UIComponents";
import { checkNegitive } from "../../common/Common";
import EyeIcon from "../common/EyeIcon";
import DocumentPreviewCarousel from "../../common/DocumentPrviewCarousal";
import { buildCashReceiptCarouselItems } from "./cashReceiptPreviewUtils";

const PrepaidAmountWithPreview = ({
  amount,
  cashReceiptLegs = [],
  variant = "default",
}) => {
  const isCompact = variant === "compact";
  const [visible, setVisible] = useState(false);
  const carouselItems = useMemo(
    () => buildCashReceiptCarouselItems(cashReceiptLegs),
    [cashReceiptLegs]
  );
  const hasReceipts = carouselItems.length > 0;

  if (amount == null || amount === "" || Number(amount) <= 0) {
    return null;
  }

  const formattedAmount = checkNegitive(amount);

  return (
    <>
      <div
        className="prepaid-amount-banner-with-actions"
        data-testid="prepaid-amount-banner"
        style={{
          display: "inline-flex",
          alignItems: "center",
          alignSelf: "flex-start",
          width: "fit-content",
          maxWidth: "100%",
          background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)",
          border: "1px solid #a7f3d0",
          borderRadius: isCompact ? "14px" : "24px",
          padding: isCompact ? "4px 10px 4px 8px" : "8px 16px 8px 20px",
          marginTop: isCompact ? 0 : 12,
          marginBottom: isCompact ? 0 : 12,
          boxShadow: isCompact
            ? "0 1px 4px rgba(16, 185, 129, 0.12)"
            : "0 2px 8px rgba(16, 185, 129, 0.15)",
          gap: isCompact ? 6 : 10,
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: isCompact ? 18 : 24,
            height: isCompact ? 18 : 24,
            borderRadius: "50%",
            backgroundColor: "#10b981",
            color: "#fff",
            flexShrink: 0,
            fontSize: isCompact ? 11 : 14,
            fontWeight: "bold",
          }}
        >
          $
        </span>
        <span style={{ display: "flex", alignItems: "center", gap: isCompact ? 4 : 6 }}>
          <span
            style={{
              fontSize: isCompact ? 11 : 13,
              color: "#047857",
              fontWeight: 600,
              letterSpacing: "0.2px",
            }}
          >
            Prepaid Amount:
          </span>
          <span
            style={{
              fontSize: isCompact ? 12 : 16,
              color: "#065f46",
              fontWeight: 700,
            }}
          >
            {formattedAmount}
          </span>
        </span>
        {hasReceipts && (
          <>
            <span
              style={{
                width: 1,
                height: isCompact ? 16 : 22,
                backgroundColor: "#a7f3d0",
                flexShrink: 0,
              }}
            />
            <Tooltip title="View Cash Receipts">
              <span
                data-testid="cash-receipt-preview-eye"
                style={{
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  paddingLeft: 2,
                }}
              >
                <EyeIcon
                  handleClick={(event) => {
                    event?.stopPropagation?.();
                    setVisible(true);
                  }}
                  color="#047857"
                  styleObj={{ fontSize: isCompact ? 14 : 18 }}
                />
              </span>
            </Tooltip>
          </>
        )}
      </div>
      {hasReceipts && (
        <Modal
          visible={visible}
          onCancel={() => setVisible(false)}
          footer={null}
          width={800}
          title="Cash Receipts"
          destroyOnClose
        >
          <DocumentPreviewCarousel items={carouselItems} enableSelection={false} />
        </Modal>
      )}
    </>
  );
};

export default PrepaidAmountWithPreview;
